import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { ByTheNumbers } from '../components/ByTheNumbers';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-2342">
      <div className="dark" data-id="element-2343">
        <Hero data-id="element-2344" />
      </div>
      <WhyUs data-id="element-2345" />
      <ByTheNumbers data-id="element-2346" />
      <Services data-id="element-2347" />
      <HowItWorks data-id="element-2348" />
      <FAQ data-id="element-2349" />
      <Reviews data-id="element-2350" />
      <CtaBanner data-id="element-2351" />
    </main>;
}